// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4c45ac6e","732":"9b477983","977":"049f7fc3"}[chunkId] + ".chunk.js";
};